import { useQuery } from '@tanstack/react-query';
import { getPartialRescues } from 'src/backend/donations';

export default function useGetPartialRescues(id, options_ = {}) {
  const { type = 'donation', ...options } = options_;
  return useQuery({
    queryKey: ['get-rescues-by-donation-id', id, type],
    queryFn: () => getPartialRescues(id, type),
    refetchOnWindowFocus: false,
    ...options,
  });
}
